import { twMerge } from "tailwind-merge"

const youtubePartsRegEx = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/

const isString = (s: string) => !!s && typeof s === "string"

const isYoutubeId = (url: string) =>
  isString(url) && !/^http(s?):\/\//.test(url) && url.length === 11

const makeEmbed = (id: string) => `https://www.youtube.com/embed/${id}`

const makeEmbedUrl = (url: string): string => {
  // If is url
  let videoId: string
  if (!isYoutubeId(url)) {
    const parts = url.match(youtubePartsRegEx)
    if (!parts?.length) {
      return ""
    }
    ;[, , videoId] = parts
  } else {
    // most likely a youtube video id
    videoId = url
  }

  return makeEmbed(videoId)
}

export const EmbedVideo = ({
  url,
  className,
  ...props
}: { url: string } & React.HTMLAttributes<HTMLDivElement>) => {
  const embedUrl = makeEmbedUrl(url)

  return (
    <div
      className={twMerge("relative", className)}
      style={{ "--aspect-ratio": 16 / 9 } as React.CSSProperties}
      {...props}
    >
      <div
        className="before:content-[''] before:block before:pb-[calc(100%/(var(--aspect-ratio)))]"
        style={{ "--aspect-ratio": 16 / 9 } as React.CSSProperties}
      />
      <iframe
        src={embedUrl}
        title="Embedded video"
        frameBorder="0"
        className="absolute left-0 top-0 h-full w-full"
        allow="encrypted-media"
        allowFullScreen
      />
    </div>
  )
}
